
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class BudgetTable extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;    
    @Prop({ default: () => 'LineItem' })
    costOption!: String;
        
    forceReload = 0;

    updateLineSum(activityId: any, dailyCost: any, item: any) {
      const id = item.id;
      this.$emit('lineValueChanged', {id, activityId, dailyCost})
    }
    calculatePlanCostTotal(budgetLineItems:any) {
      return budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.planCost || 0),
        0
      ).toFixed(2);
    }

    calculatePlanTotal(data:any) {
      return data.reduce(
        (acc:any, item:any) => acc + parseFloat(item.plan || 0),
        0
      ).toFixed(2);
    }

    calculateActualLumpSumTotal(data:any) {
      return data.reduce(
        (acc:any, item:any) => acc + parseFloat(item.actualCost || 0),
        0
      ).toFixed(2);
    }

    calculateAFEActualLumpSumTotal(data:any) {
      return data.reduce(
        (acc:any, item:any) => acc + parseFloat(item.afeCost || 0),
        0
      ).toFixed(2);
    }

    calculateActualDailyCumTotal(data:any) {
      return data.reduce(
        (acc:any, item:any) => acc + parseFloat(item.actualDailyCumulativeCost || 0),
        0
      ).toFixed(2);
    }

    calculateVarianceCostTotal(data:any) {
      return data.reduce(
        (acc:any, item:any) => acc + parseFloat(item.variance || 0),
        0
      ).toFixed(2);
    }

    calculateActualCostTotal(budgetLineItems:any) {
      return budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.actualCost || 0),
        0
      ).toFixed(2);
    }

    calculateDailyCostTotal(budgetLineItems:any) {
      return budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.dailyCost || 0),
        0
      ).toFixed(2);
    }

    calculateVarianceTotal(budgetLineItems:any) {
      const plan = budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.planCost || 0),
        0
      ).toFixed(2);
      const daily = budgetLineItems.reduce(
        (acc:any, item:any) => acc + parseFloat(item.dailyCost || 0),
        0
      ).toFixed(2);
      return plan - daily;
    }

    calculatePlanForDepartment(department: string) {
      return this.formattedDepartmentData
        .filter(row => row.department === department)
        .reduce((acc, item) => acc + parseFloat(item.plan || 0), 0).toFixed(2);
    }

    calculateActualLumpSumForDepartment(department: string) {
      return this.formattedDepartmentData
        .filter(row => row.department === department)
        .reduce((acc, item) => acc + parseFloat(item.actualCost || 0), 0).toFixed(2);
    }

    calculateActualDailyCumForDepartment(department: string) {
      return this.formattedDepartmentData
        .filter(row => row.department === department)
        .reduce((acc, item) => acc + parseFloat(item.actualDailyCumulativeCost || 0), 0).toFixed(2);
    }

    calculateVarianceForDepartment(department: string) {
      return this.formattedDepartmentData
        .filter(row => row.department === department)
        .reduce((acc, item) => acc + parseFloat(item.variance || 0), 0).toFixed(2);
    }

    calculatePlanTotalForDepartment(department: string) {
      return this.formattedData
        .filter(row => row.department === department)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.planCost || 0), 0).toFixed(2);
    }
    calculateDailyTotalForDepartment(department: string) {
      return this.formattedData
        .filter(row => row.department === department)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.dailyCost || 0), 0).toFixed(2);
    }
    calculateActualTotalForDepartment(department: string) {
      return this.formattedData
        .filter(row => row.department === department)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.actualCost || 0), 0).toFixed(2);
    }
    calculateVarianceTotalForDepartment(department: string) {
        const plan = this.formattedData
            .filter(row => row.department === department)
            .flatMap(row => row.budgetLineItems)
            .reduce((acc, item) => acc + parseFloat(item.planCost || 0), 0).toFixed(2);

        const daily = this.formattedData
            .filter(row => row.department === department)
            .flatMap(row => row.budgetLineItems)
            .reduce((acc, item) => acc + parseFloat(item.dailyCost || 0), 0).toFixed(2);

        return plan - daily;
    }

    calculatePlanForProject(project: string) {
      return this.formattedAfeLumpSumData
        .filter(row => row.project === project)
        .reduce((acc, item) => acc + parseFloat(item.plan || 0), 0).toFixed(2);
    }

    calculateActualLumpSumForProject(project: string) {
      return this.formattedAfeLumpSumData
        .filter(row => row.project === project)
        .reduce((acc, item) => acc + parseFloat(item.afeCost || 0), 0).toFixed(2);
    }

    calculateActualDailyCumForProject(project: string) {
      return this.formattedAfeLumpSumData
        .filter(row => row.project === project)
        .reduce((acc, item) => acc + parseFloat(item.actualDailyCumulativeCost || 0), 0).toFixed(2);
    }

    calculateVarianceForProject(project: string) {
      return this.formattedAfeLumpSumData
        .filter(row => row.project === project)
        .reduce((acc, item) => acc + parseFloat(item.variance || 0), 0).toFixed(2);
    }

    calculatePlanTotalForOperationUnit(operationunit: string) {
      return this.formattedData
        .filter(row => row.operationunit === operationunit)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.planCost || 0), 0).toFixed(2);
    }
    calculateDailyTotalForOperationUnit(operationunit: string) {
      return this.formattedData
        .filter(row => row.operationunit === operationunit)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.dailyCost || 0), 0).toFixed(2);
    }
    calculateActualTotalForOperationUnit(operationunit: string) {
      return this.formattedData
        .filter(row => row.operationunit === operationunit)
        .flatMap(row => row.budgetLineItems)
        .reduce((acc, item) => acc + parseFloat(item.actualCost || 0), 0).toFixed(2);
    }
    calculateVarianceTotalForOperationUnit(operationunit: string) {
        const plan = this.formattedData
            .filter(row => row.operationunit === operationunit)
            .flatMap(row => row.budgetLineItems)
            .reduce((acc, item) => acc + parseFloat(item.planCost || 0), 0).toFixed(2);

        const daily = this.formattedData
            .filter(row => row.operationunit === operationunit)
            .flatMap(row => row.budgetLineItems)
            .reduce((acc, item) => acc + parseFloat(item.dailyCost || 0), 0).toFixed(2);

        return plan - daily;
    }

    planCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.plan || 0), 0);
    }
    actualCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualBudgetCost || 0), 0);
    }
    actualDailyCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualDailyBudgetCost || 0), 0);
    }
    varianceCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.variance || 0), 0);
    }

    // Data to track collapsed departments
    collapsedDepartments: Record<string, boolean> = {};

    toggleDepartment(department: string) {
        this.$set(this.collapsedDepartments, department, !this.isDepartmentCollapsed(department));
    }

    isDepartmentCollapsed(department: string): boolean {
        return this.collapsedDepartments[department] || false;
    }

    collapsedOperationUnits: Record<string, boolean> = {};

    toggleOperationUnit(operationUnit: string) {
        this.$set(this.collapsedOperationUnits, operationUnit, !this.isOperationUnitCollapsed(operationUnit));
    }

    isOperationUnitCollapsed(operationUnit: string): boolean {
        return this.collapsedOperationUnits[operationUnit] || false;
    }

    get formattedData() {
      const budget = this.rows.map((item: any) => ({
        activityId: item.activityId,
        department: item.department,
        milestone: item.milestone,
        operationunit: item.operationunit,
        planBudgetSection: item.planBudgetSection,
        actualSection: item.actualSection,
        lumpSumCost: item.lumpSumCost ? item.lumpSumCost.lineValue : 0,
        budgetLineItems: item.actualSection.budgetLineItems.map((line: any) => {
          const planLine = item.planCost ? item.planCost.budgetLines.find((x: any) => String(x.lineItemId) === String(line.id)) : 0;
          const actualLine = item.actualCost ? item.actualCost.budgetLines.find((x: any) => String(x.lineItemId) === String(line.id)) : 0;
          const dailyLine = item.actualDailyCummulativeCost ? item.actualDailyCummulativeCost.budgetLines.find((x: any) => String(x.lineItemId) === String(line.id)) : 0;
          return {
            ...line,
            dailyCost: dailyLine ? dailyLine.lineValue : 0,
            planCost: planLine ? planLine.lineValue : 0,
            actualCost: actualLine ? actualLine.lineValue : 0,
          };
        }),
      }));
      return budget;
    }

    get formattedDepartmentData() {
      const budget = this.rows.map((item: any) => (
        {  
          department: item.department,
          departmentId: item.departmentId,
          plan: item.plan,
          actualCost: item.actualCost,
          actualDailyCumulativeCost: item.actualDailyCumulativeCost,
          variance: item.variance
        }
      ));
      return budget;
    }

    get formattedAfeLumpSumData() {
      const budget = this.rows.map((item: any) => (
        {  
          project: item.project,
          projectId: item.projectId,
          plan: item.plan,
          afeCost: item.afeCost,
          actualDailyCumulativeCost: item.actualDailyCumulativeCost,
          variance: item.variance
        }
      ));
      return budget;
    }

    get formattedProjectCostData() {
      const budget = this.rows.map((item: any) => (
        {  
          lineItem: item.lineItem,
          plan: item.plan,
          actualBudgetCost: item.actualBudgetCost,
          actualDailyBudgetCost: item.actualDailyBudgetCost,
          variance: item.variance,
          sectionName: item.sectionName,
        }
      ));
      return budget;
    }

    mounted() {
      this.forceReload += 1;
    }
}
